import { format, isToday, parse, parseISO } from 'date-fns';
import { NO_DATA } from '../Base.constants';

export const DATE_FORMATS = {
  MONTH_ABBR_DATE: 'dd MMM yy',
  YEAR_MONTH_DAY: 'yyyy-MM-dd',
  TIME: 'hh:mm a',
  DATE_TIME: 'dd MMM yy, hh:mm a',
  MONTH_YEAR: 'MMMM yyyy',
  MONTH_YEAR_MLA: 'MMM yyyy',
  MONTH_DAY_YEAR: 'MM/dd/yy',
};

export const formatDate = (
  date: string | Date | undefined | null,
  dateFormat: string = DATE_FORMATS.MONTH_ABBR_DATE,
  fallbackValue = NO_DATA
): string => {
  try {
    if (date == null) {
      return fallbackValue;
    }
    if (typeof date === 'string') {
      const parsedDate = parseISO(date);
      return format(parsedDate, dateFormat);
    }
    return format(date, dateFormat);
  } catch (e) {
    return fallbackValue;
  }
};

export const isCurrentDate = (date: string): boolean => {
  try {
    const parsedDate = parseISO(date);
    return isToday(parsedDate);
  } catch (e) {
    return false;
  }
};

export const formatCommonDate = (date: string | undefined, useToday?: boolean): string =>
  useToday && date && isCurrentDate(date)
    ? 'Today'
    : formatDate(date, date && isCurrentDate(date) ? DATE_FORMATS.TIME : DATE_FORMATS.MONTH_ABBR_DATE);

export const parseDate = (date: string, format: string = DATE_FORMATS.MONTH_ABBR_DATE): Date =>
  parse(date, format, new Date());

export const formatUTCDate = (
  date: string | Date | undefined | null,
  dateFormat: string = DATE_FORMATS.MONTH_ABBR_DATE,
  fallbackValue = NO_DATA
): string => {
  try {
    if (date == null) {
      return fallbackValue;
    }
    let parsedDate;
    if (typeof date === 'string') {
      parsedDate = parseISO(date);
    } else {
      parsedDate = date;
    }
    // Create a Date object in UTC by adding the timezone offset
    const utcDate = new Date(parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000);
    return format(utcDate, dateFormat);
  } catch (e) {
    return fallbackValue;
  }
};
